import {v4 as uuidv4} from 'uuid';
import {IS_CLIENT_SIDE} from '../../../../common/shared/utils/constants';

const SESSION_STORAGE_REDIRECT_KEY_PREFIX = 'redirect_key_';

export function generateRelayRedirectUrl(callbackUrl: string) {
  if (!IS_CLIENT_SIDE) {
    return;
  }
  const uuid = uuidv4().substring(0, 15);
  const storageKey = `${SESSION_STORAGE_REDIRECT_KEY_PREFIX}_${uuid}`;
  window.sessionStorage.setItem(storageKey, callbackUrl);
  return `${window.location.origin}/relay/redirect/${storageKey}`;
}
